import React, { useState } from 'react'
import axios from './shared/axios'

export default function DismissableAnnouncement({ name, dismissed,image, headline, body, url}) {
  const [isVisible, setIsVisible] = useState(true);

  const handleDismiss = async () => {
    setIsVisible(false);
    await axios.post('/announcements/dismiss', { name });
  };

  if (dismissed || !isVisible) return null;

  return (
    <div className="py-3 px-4 bg-primary text-white">
      <div className="row">
        {image && (
          <div className="col-auto pe-0 ps-2">
            <h3 className="m-0">
              {image.startsWith('http') ? (
                <img src={image} alt="" className="announcement-image" />
              ) : (
                image
              )}
            </h3>
          </div>
        )}
        <div className="col ps-2">
          {headline && <h4 className="text-white rem-1 m-0">{headline}</h4>}
          {body && <p className="m-0 text-kinda-faded fw-normal">{body}</p>}
        </div>
        {url && (
          <div className="col-auto pe-0">
            <a href={url} className="btn btn-white">
              Read More
            </a>
          </div>
        )}
        <div className="col-auto">
          <button
            className="btn btn-outline-white"
            onClick={handleDismiss}
            aria-label="Dismiss announcement"
          >
            Dismiss
          </button>
        </div>
      </div>
    </div>
  );
}